import React from "react";
import defaultProfile from "../../../images/avatar/defaultuser.png";
import "./style.css";

export const getImageUrl = (imagePath) => {
  let imageUrl = defaultProfile;
  if (imagePath) {
    // Use the custom domain format that matches the working URL
    imageUrl = `https://abhivyakti-assets.stimulusco.com/${imagePath}`;
    // imageUrl = `https://d2nvc4xuh5a6ia.cloudfront.net/${imagePath}`;
  }
  return imageUrl;
};

const ArtistAvatar = ({ artist, removeArtist, handleClick, allowDelete = true, allowEdit = true, role }) => {
  const imageUrl = getImageUrl(artist?.profile_image);

  return (
    <div
      className="position-relative artist-avatar text-center"
      onClick={allowEdit ? handleClick : null}
    >
      {allowDelete ? (
        <i
          class="position-absolute fa-solid fa-circle-xmark"
          onClick={(e) => {
            e.stopPropagation();
            removeArtist();
          }}
        ></i>
      ) : null}
      <img src={imageUrl} className="mb-1" />
      <p className="fs-14">{`${artist.firstName} ${artist.lastName}`}</p>
      <span className="fw-normal">{role}</span>
    </div>
  );
};

export default ArtistAvatar;
